module.exports = __webpack_public_path__ + "img/netBuilding_89x69.fe09a89a.svg";